import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from '@studio-freight/lenis';
import { LanguageProvider } from "./context/LanguageContext";
import { trackEvent } from "./utils/tracking";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Clients } from "./components/Clients";
import { Differentiator } from "./components/Differentiator";
import { CTA } from "./components/CTA";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Pricing } from "./components/Pricing";
import AdminPage from "./pages/AdminPage";
import FormPage from "./pages/FormPage";

// Homepage Component
const HomePage = () => {
  useEffect(() => {
    trackEvent('page_view');
  }, []);

  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f6e2]">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" aria-hidden="true" />
      
      {/* Header */}
      <Header />
      
      {/* Main content */}
      <main>
        <Hero />
        <About />
        <Services />
        <Clients />
        <Differentiator />
        <Pricing />
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Floating WhatsApp button */}
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/form" element={<FormPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
